import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_SEEN_NEW_FEATURE_SHEPHERDS = createAsyncActionTypes('FETCH_SEEN_NEW_FEATURE_SHEPHERDS');
export const UPDATE_SEEN_NEW_FEATURE_SHEPHERDS = createAsyncActionTypes('UPDATE_SEEN_NEW_FEATURE_SHEPHERDS');